(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/OneDaciaHeaderMobile"] = factory();
	else
		root["@makolab/library-react/dist/OneDaciaHeaderMobile"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 284);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/withEventService");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderMobile", function() { return HeaderMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_icon__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icon_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__icon_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_event_service__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commons_event_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__commons_event_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_with_event_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commons_with_event_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__commons_with_event_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__header_mobile_jss__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__header_mobile_types__ = __webpack_require__(286);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderMobile=function(_Component){_inherits(HeaderMobile,_Component);function HeaderMobile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HeaderMobile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HeaderMobile.__proto__||Object.getPrototypeOf(HeaderMobile)).call.apply(_ref,[this].concat(args))),_this),_this.menuHandler=function(){__WEBPACK_IMPORTED_MODULE_5__commons_event_service___default.a.emit('header/menu-open',null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HeaderMobile,[{key:'render',value:function render(){var _props=this.props,classes=_props.classes,logo=_props.logo,url=_props.url,_props$wording=_props.wording,menu=_props$wording.menu,vehicles=_props$wording.vehicles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.root)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:logo.url,title:logo.alt},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icon_icon___default.a,{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.logo),id:'DaciaMainHeader',size:{width:120,height:13}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.title)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.button,classes.leftButton),onClick:function onClick(){window.location.href=url;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 30 30',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonIcon)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M20.189 19.394c-.883 0-1.459.575-1.459 1.42 0 .844.576 1.42 1.459 1.42.882 0 1.458-.576 1.458-1.42 0-.845-.576-1.42-1.458-1.42zM13.473 6c3.147 0 4.643.422 6.485 1.765l3.416 2.533 2.303.653c2.302.652 3.607 1.957 4.49 4.375h-1.344c-.844-1.804-1.88-2.687-3.914-3.262l-2.303-.653-3.338-2.494c-1.574-1.152-3.147-1.612-5.795-1.612H9.25V6h4.222zm-.768 2.61c3.032 0 4.567.422 6.486 1.88l2.878 2.15 2.38.652c2.264.614 3.453 2.11 3.799 4.758h-1.343c-.346-2.072-1.267-3.108-3.224-3.645l-2.38-.653-2.801-2.11c-1.65-1.267-3.262-1.728-5.795-1.728H7.908V8.61h4.797zM6.488 19.394c-.883 0-1.458.575-1.458 1.42 0 .844.575 1.42 1.458 1.42s1.458-.576 1.458-1.42c0-.845-.575-1.42-1.458-1.42zm10.976 1.42c0-1.535 1.151-2.687 2.725-2.687 1.573 0 2.724 1.152 2.724 2.687S21.763 23.5 20.19 23.5c-1.075 0-1.958-.537-2.418-1.382H8.906c-.46.845-1.344 1.382-2.418 1.382-1.574 0-2.725-1.151-2.725-2.686s1.151-2.687 2.725-2.687c1.573 0 2.725 1.152 2.725 2.687h8.25zM1 18.434c0-1.88.115-2.149 1.996-4.375 1.918-2.302 2.84-2.84 4.874-2.84h4.873c2.188 0 3.378.384 5.105 1.574l2.916 2.187 1.88.46c2.035.461 2.994 1.651 2.994 3.608 0 .96-.268 1.804-.767 2.495l-1.075-.768c.384-.575.499-.998.499-1.727 0-1.343-.69-2.072-2.418-2.494l-1.88-.46-2.84-2.15c-1.382-1.036-2.571-1.42-4.414-1.42H7.87c-1.574 0-2.15.384-3.915 2.495-1.458 1.765-1.612 1.995-1.612 3.607v.806c0 .576.115.921.46 1.266l-.92.845C1.269 21.005 1 20.353 1 19.432v-.998z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonLabel)},vehicles)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonSeparator)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.button),onClick:this.menuHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{viewBox:'0 0 30 30',className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonIcon)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M3.781 6H26.22a.781.781 0 0 1 0 1.563H3.78a.781.781 0 0 1 0-1.563zM3.781 14H26.22a.781.781 0 0 1 0 1.563H3.78a.781.781 0 1 1 0-1.563zM3.781 22H26.22a.781.781 0 0 1 0 1.563H3.78a.781.781 0 1 1 0-1.563z'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()(classes.buttonLabel)},menu))));}}]);return HeaderMobile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);HeaderMobile.displayName='HeaderMobile';HeaderMobile.propTypes={classes:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,logo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape(__WEBPACK_IMPORTED_MODULE_9__header_mobile_types__["a" /* HEADER_LOGO_PROP_TYPE */]).isRequired,url:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,wording:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_3_lodash_flow___default()([Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["withStyles"])(__WEBPACK_IMPORTED_MODULE_8__header_mobile_jss__["a" /* default */]),__WEBPACK_IMPORTED_MODULE_6__commons_with_event_service___default()()])(HeaderMobile));

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var menuHeight=55;/* harmony default export */ __webpack_exports__["a"] = (function(theme){return{root:_defineProperty({display:'flex',alignItems:'center',justifyContent:'space-between',height:menuHeight,borderBottom:'1px solid '+theme.palette.common.border,padding:0},theme.breakpoints.up('md'),{display:'none'}),logo:{display:'block',flexShrink:0,height:menuHeight,color:'#000000',margin:'0 '+theme.spacing.unit*2+'px'},title:{fontSize:'14px',display:'flex',alignItems:'center',fontWeight:700,color:theme.palette.primary.dark},button:{height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',border:0,background:'none',textDecoration:'none',cursor:'pointer',padding:theme.spacing.unit},buttonIcon:{width:30,display:'block'},buttonLabel:{marginTop:theme.spacing.unit/2,color:theme.palette.primary.dark,fontSize:'10px',fontWeight:500,textTransform:'capitalize'},buttonSeparator:{height:'35px',borderLeft:'1px solid '+theme.palette.common.borderSeparator}};});

/***/ }),

/***/ 286:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEADER_LOGO_PROP_TYPE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var HEADER_LOGO_PROP_TYPE={alt:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,text:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,imageMobile:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string};

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("lodash/flow");

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/eventService");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/Icon");

/***/ })

/******/ });
});
//# sourceMappingURL=OneDaciaHeaderMobile.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/OneDaciaHeaderMobile.js
// module id = 477
// module chunks = 0